var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSustainability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 587.528,
    height: 585.836,
    viewBox: "0 0 587.528 585.836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c6dc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sustainability",
    transform: "translate(-141.3 -69.746)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hand-certificate",
    transform: "translate(141.3 444.814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M232.955,482.668h-64.2A27.4,27.4,0,0,1,141.3,455.209V299.359A27.4,27.4,0,0,1,168.759,271.9h64.2a27.4,27.4,0,0,1,27.459,27.459v155.85A27.516,27.516,0,0,1,232.955,482.668ZM168.759,289.9a9.106,9.106,0,0,0-9.091,9.091v155.85a9.106,9.106,0,0,0,9.091,9.091h64.2a9.106,9.106,0,0,0,9.091-9.091V298.988a9.106,9.106,0,0,0-9.091-9.091Z",
    transform: "translate(-141.3 -271.9)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 9.091,
    cy: 9.091,
    r: 9.091,
    transform: "translate(45.827 137.296)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M470.831,368.269h-119.3a9.091,9.091,0,1,1,0-18.182h119.3a18.368,18.368,0,0,0,0-36.736h-119.3a10.111,10.111,0,0,1-4.082-.928c-.557-.186-35.252-17.44-69.2-17.44s-68.834,17.255-69.2,17.44a9.173,9.173,0,1,1-8.72-16.142l.557-.186c1.484-.928,38.962-19.3,77.368-19.3,33.767,0,66.978,14.472,75.513,18.368H470.831a36.551,36.551,0,1,1,0,73.1Z",
    transform: "translate(-94.936 -267.709)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M476.883,456.6h-.557L204.146,437.863a9.207,9.207,0,1,1,1.3-18.368l269.4,18.554L654.255,334.334a18.112,18.112,0,0,0,5.566-25.233,18.584,18.584,0,0,0-23.934-6.494l-1.3.557L480.78,362.721a9.175,9.175,0,0,1-7.607-16.7,2.637,2.637,0,0,1,1.113-.371l153.252-59.557a36.8,36.8,0,0,1,35.994,64.2L481.707,455.3A9.443,9.443,0,0,1,476.883,456.6Z",
    transform: "translate(-94.865 -263.831)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M366.123,250.615c-16.884,0-41.56-4.638-67.721-26.161h0c-46.569-38.035-40.632-82.007-40.447-83.862a9.179,9.179,0,0,1,5.937-7.236c1.67-.557,43.6-15.028,89.985,23.006s40.818,81.821,40.447,83.677a9.179,9.179,0,0,1-5.937,7.236A68.919,68.919,0,0,1,366.123,250.615Zm-56.032-40.261c29.129,23.749,55.1,23.006,66.422,21.337-.371-11.318-4.824-36.922-33.953-60.856s-55.1-23.006-66.422-21.337C276.51,160.815,280.962,186.419,310.091,210.353Z",
    transform: "translate(99.493 51.708)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M405.579,257.033a72.107,72.107,0,0,1-43.23-13.173,9.113,9.113,0,0,1-3.154-8.906c.371-1.484,7.978-36.922,54.176-53.249s74.4,6.494,75.7,7.421a9.113,9.113,0,0,1,3.154,8.906c-.371,1.484-7.978,36.922-54.176,53.249h0A101.333,101.333,0,0,1,405.579,257.033Zm-26.16-24.305c8.349,4.267,26.532,10.2,52.692,1.113h0c25.975-9.091,36.736-25.233,40.261-33.953-8.349-4.267-26.532-10.2-52.692-1.113C393.705,208.052,383.13,224.193,379.419,232.728Z",
    transform: "translate(186.201 90.745)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M569.434,413.1c-7.236-19.667-18.739-32.654-33.768-38.962-21.151-8.72-44.343-1.113-57.887,4.638-19.481-27.459-41.56-35.808-58.258-37.478a503.717,503.717,0,0,1,11.132-97.221,416.644,416.644,0,0,1,28.758-90.356,9.221,9.221,0,0,0-16.7-7.607v.371a433.777,433.777,0,0,0-29.686,93.324,551.1,551.1,0,0,0-11.874,101.673,107.523,107.523,0,0,0-60.113,32.1c-42.488-19.3-73.843,9.091-84.975,28.2a9.109,9.109,0,0,0,4.638,12.06,8.974,8.974,0,0,0,11.132-2.969c2.6-4.267,26.161-41.189,66.978-18a9.452,9.452,0,0,0,11.874-2.412c10.576-13.73,37.478-32.469,64.2-31.355,20.223.928,37.664,12.987,51.95,35.808a9.355,9.355,0,0,0,11.689,3.525c9.648-4.638,32.1-15.028,50.466-7.607,10.2,4.082,18,13.73,23.563,28.387a9.236,9.236,0,0,0,8.535,5.937,8.668,8.668,0,0,0,3.154-.557C568.692,423.123,571.1,417.928,569.434,413.1Z",
    transform: "translate(97.488 61.396)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M408.051,228.665a114.909,114.909,0,0,1-46.569-9.462,9.361,9.361,0,0,1-5.009-6.494c-.557-2.783-12.431-67.72,50.466-115.4s121.9-19.3,124.494-18a9.361,9.361,0,0,1,5.01,6.494c.557,2.783,12.431,67.535-50.466,115.4A126.172,126.172,0,0,1,408.051,228.665Zm-34.139-24.12c13.73,5.009,56.032,16.142,100.931-18,44.9-34.324,45.085-78.482,43.972-92.768-13.544-5.009-56.217-16.142-100.931,18h0C373.356,145.916,372.8,190.259,373.912,204.545Z",
    transform: "translate(182.987)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSustainability);
export default __webpack_public_path__ + "static/media/sustainability.f116a9329112e0ca541c21d38874d84b.svg";
export { ForwardRef as ReactComponent };